import { Button, Modal, Pagination, Table } from 'rsuite';
import styles from './ModalPriceSources.module.scss';
import { LoadingSpinerArea } from '../../../../../../components/LoadingSpinner';
import { DetailsSourceResponse } from '../../types';

export interface IModalPriceSources {
  onClose(): void;
  onPageChange(page: number): void;
  show: boolean;
  loading: boolean;
  productName?: string;
  productCode?: string;
  priceSources?: DetailsSourceResponse;
  sourceHeaderData?: {
    productName?: string;
    productCode?: string;
  };
}

const { HeaderCell, Cell } = Table;
const Column = Table.Column as any;

const formatPrice = (value: number | null | undefined) => (value != null ? `R$ ${value.toFixed(2).replace('.', ',')}` : '-');
const formatCompetitividade = (value: number | null | undefined) => (value != null ? `${value.toFixed(1).replace('.', ',')} %` : '-');

const removeFisicoSources = (content?: DetailsSourceResponse['content']) => content?.filter(item => !item?.canal?.includes('Fisico')) ?? [];

export const ModalPriceSources = ({ show, onClose, onPageChange, loading, sourceHeaderData, priceSources }: IModalPriceSources) => {
  const pageNumber = priceSources?.number ?? 0;
  const totalElements = priceSources?.totalElements ?? 0;
  const activePage = (typeof pageNumber === 'number' ? pageNumber : 0) + 1;
  const filteredContent = removeFisicoSources(priceSources?.content);
  const displayLength = filteredContent.length;

  return (
    <Modal size="md" overflow={false} backdrop="static" show={show} className={styles['modal-container']} onHide={onClose}>
      <LoadingSpinerArea loading={loading} size="md" position="absolute" />
      <Modal.Header closeButton onHide={onClose}>
        <div className={styles['header-content']}>
          <h1 className={styles['header-title']}>Fontes dos preços</h1>
          <div className={styles['price-sources-info']}>
            <p className={styles['product-name']}>{sourceHeaderData?.productName}</p>
            <p className={styles['product-code']}>{sourceHeaderData?.productCode}</p>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className={styles['table-wrapper']}>
          <Table bordered headerHeight={46} data={filteredContent} height={280} className={styles['price-sources-table']}>
            <Column flexGrow={1}>
              <HeaderCell>Fonte do preço</HeaderCell>
              <Cell dataKey="fonteDigital" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Preço</HeaderCell>
              <Cell dataKey="preco">{(rowData: { preco: number }) => formatPrice(rowData.preco)}</Cell>
            </Column>
            <Column flexGrow={1}>
              <HeaderCell className={styles['competitivity-header']}>
                <div>
                  <p>Competitividade em relação</p>
                  <p>ao preço PDV</p>
                </div>
              </HeaderCell>
              <Cell dataKey="competitividade" className={styles['competitivity-cell']}>
                {(rowData: { competitividade: number }) => formatCompetitividade(rowData.competitividade)}
              </Cell>
            </Column>
          </Table>
        </div>
        {priceSources && priceSources?.totalElements && priceSources?.totalElements > 0 && (
          <Pagination
            className={styles['products-pagination']}
            activePage={activePage}
            displayLength={displayLength}
            showLengthMenu={false}
            total={totalElements}
            onChangePage={(e: number) => onPageChange(e - 1)}
            renderTotal={() => `Exibindo ${filteredContent.length} de ${priceSources?.totalElements ?? 0} fontes de preço.`}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} appearance="primary" className={styles['close-btn']}>
          FECHAR
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
